import styled from 'styled-components';
export const ScanDocumentWrapper = styled.div `
  .csl-box {
    padding: 0;
  }

  #mitekGuide {
    width: 100% !important;
    height: 80% !important;
  }

  .csl-list-loading {
    width: 100%;
    height: 400px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;
export const AutoCaptureButtonWrapper = styled.div `
  visibility: hidden;
`;
//# sourceMappingURL=styles.js.map